import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC, ReactNode } from 'react';
import { useId, useState } from 'react';
import { getExpandableCardHeaderStyles } from 'src/components/data-display/expandable-card';

type ActivityExpandableCardProps = {
  header: ReactNode;
  children: ReactNode;
} & (
  | {
      /** Optional controlled expansion state. */
      isExpanded: boolean;
      /** Optional controlled expansion state. */
      setIsExpanded: (expanded: boolean) => void;
    }
  | {
      /** Optional controlled expansion state. */
      isExpanded?: undefined;
      /** Optional controlled expansion state. */
      setIsExpanded?: undefined;
    }
);

export const ActivityExpandableCard: FC<ActivityExpandableCardProps> = ({
  header,
  children,
  isExpanded: isExternalExpanded,
  setIsExpanded: setIsExternalExpanded,
}) => {
  const id = useId();
  const [isInternalExpanded, setInternalExpanded] = useState(true);
  const isExpanded = isExternalExpanded ?? isInternalExpanded;
  const setExpanded = setIsExternalExpanded ?? setInternalExpanded;
  return (
    <div>
      <div
        role="button"
        className={getExpandableCardHeaderStyles({
          isExpanded,
          mode: 'default',
        })}
        aria-expanded={isExpanded}
        aria-controls={id}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setExpanded(!isExpanded);
            // .preventDefault() required because of role=”button”
            e.preventDefault();
          }
        }}
        onClick={() => setExpanded(!isExpanded)}
      >
        <div className="grid grid-cols-[1fr_auto] items-center gap-md">
          <div>{header}</div>

          <FontAwesomeIcon
            icon={isExpanded ? faCaretUp : faCaretDown}
            aria-hidden="true"
            className="accepted-exception:text-[25px]"
          />
        </div>
      </div>

      {isExpanded && <div id={id}>{children}</div>}
    </div>
  );
};
